/* evvOlife theme.js — lightweight, no framework */
(function(){
  'use strict';

  const $  = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => Array.from(c.querySelectorAll(s));

  /* ---------- Drawer system ---------- */
  const overlay = $('[data-overlay]');
  function openDrawer(id){
    const drawer = document.getElementById(id);
    if(!drawer) return;
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer(drawer){
    if(drawer) drawer.classList.remove('is-open');
    else $$('.drawer.is-open').forEach(d => d.classList.remove('is-open'));
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('click', e => {
    const trigger = e.target.closest('[data-drawer-open]');
    if(trigger){ e.preventDefault(); openDrawer(trigger.dataset.drawerOpen); return; }
    if(e.target.closest('[data-drawer-close]') || e.target === overlay){ closeDrawer(); }
  });
  document.addEventListener('keydown', e => { if(e.key === 'Escape') closeDrawer(); });

  /* ---------- Mobile menu: sub-pane navigation ---------- */
  document.addEventListener('click', e => {
    const openSub = e.target.closest('[data-open-sub]');
    if(openSub){
      e.preventDefault();
      const label = openSub.dataset.openSub;
      const panes = openSub.closest('[data-panes]');
      if(!panes) return;
      const target = panes.querySelector(`[data-pane="sub-${CSS.escape(label)}"]`);
      if(!target) return;
      $$('.mobile-menu__pane', panes).forEach(p => p.classList.remove('is-active'));
      target.classList.add('is-active');
      return;
    }
    const back = e.target.closest('[data-back-sub]');
    if(back){
      e.preventDefault();
      const panes = back.closest('[data-panes]');
      if(!panes) return;
      $$('.mobile-menu__pane', panes).forEach(p => p.classList.remove('is-active'));
      panes.querySelector('[data-pane="root"]').classList.add('is-active');
      return;
    }
  });
  // Reset to root pane when drawer closes
  const _origCloseDrawer = window.closeDrawer; // no-op, we monkey-patch via overlay close indirectly
  document.addEventListener('click', e => {
    if(e.target.matches('[data-overlay]') || e.target.closest('[data-drawer-close]')){
      setTimeout(() => {
        $$('.mobile-menu [data-panes]').forEach(panes => {
          $$('.mobile-menu__pane', panes).forEach(p => p.classList.remove('is-active'));
          const root = panes.querySelector('[data-pane="root"]');
          if(root) root.classList.add('is-active');
        });
      }, 350);
    }
  });

  /* ---------- Sticky header shadow ---------- */
  const header = $('.site-header');
  if(header){
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ---------- Announcement bar rotation ---------- */
  $$('.announcement-bar[data-rotate]').forEach(bar => {
    const items = $$('.announcement-bar__item', bar);
    if(items.length < 2) return;
    let i = 0;
    items[0].style.display = 'block';
    setInterval(() => {
      items[i].style.display = 'none';
      i = (i + 1) % items.length;
      items[i].style.display = 'block';
    }, 4500);
  });

  /* ---------- Hero slideshow ---------- */
  $$('[data-hero]').forEach(hero => {
    const slides = $$('.hero-slide', hero);
    const dots = $$('.hero-dots button', hero);
    if(slides.length < 2){ if(slides[0]) slides[0].classList.add('is-active'); return; }
    let idx = 0, timer;
    const go = n => {
      slides[idx].classList.remove('is-active');
      dots[idx] && dots[idx].classList.remove('is-active');
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add('is-active');
      dots[idx] && dots[idx].classList.add('is-active');
    };
    const auto = parseInt(hero.dataset.autoplay, 10);
    const start = () => { if(auto) timer = setInterval(() => go(idx+1), auto); };
    const stop  = () => clearInterval(timer);
    dots.forEach((d,i) => d.addEventListener('click', () => { go(i); stop(); start(); }));
    $('.hero-arrow--prev', hero)?.addEventListener('click', () => { go(idx-1); stop(); start(); });
    $('.hero-arrow--next', hero)?.addEventListener('click', () => { go(idx+1); stop(); start(); });
    // Swipe
    let sx=0;
    hero.addEventListener('touchstart', e => sx = e.touches[0].clientX, {passive:true});
    hero.addEventListener('touchend', e => {
      const dx = e.changedTouches[0].clientX - sx;
      if(Math.abs(dx) > 40){ go(dx > 0 ? idx-1 : idx+1); stop(); start(); }
    });
    start();
  });

  /* ---------- Product gallery ---------- */
  $$('[data-product-gallery]').forEach(gallery => {
    const main = $('[data-main-image]', gallery);
    const thumbs = $$('[data-thumb]', gallery);
    thumbs.forEach(t => t.addEventListener('click', () => {
      thumbs.forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
      const src = t.dataset.thumb;
      if(main) main.src = src;
    }));
  });

  /* ---------- Quantity inputs ---------- */
  document.addEventListener('click', e => {
    const inc = e.target.closest('[data-qty-inc]');
    const dec = e.target.closest('[data-qty-dec]');
    if(inc || dec){
      const wrap = (inc||dec).closest('.qty-input,.cart-item__qty');
      const input = $('input[type=number]', wrap);
      if(!input) return;
      let v = parseInt(input.value, 10) || 1;
      v = inc ? v+1 : Math.max(parseInt(input.min||1,10), v-1);
      input.value = v;
      input.dispatchEvent(new Event('change', {bubbles:true}));
    }
  });

  /* ---------- Cart drawer fetch (AJAX add) ---------- */
  async function refreshCart(){
    try{
      const res = await fetch('/?section_id=cart-drawer');
      const html = await res.text();
      const wrap = document.createElement('div');
      wrap.innerHTML = html;
      const fresh = wrap.querySelector('#CartDrawer');
      const cur = $('#CartDrawer');
      if(fresh && cur) cur.innerHTML = fresh.innerHTML;
      const c = await fetch('/cart.js').then(r=>r.json());
      $$('[data-cart-count]').forEach(el => {
        el.textContent = c.item_count;
        el.style.display = c.item_count > 0 ? '' : 'none';
      });
    }catch(e){ /* silent */ }
  }
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if(!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type=submit]');
    const orig = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.innerHTML = '<span class="spinner"></span>'; }
    try{
      const fd = new FormData(form);
      const res = await fetch('/cart/add.js', { method:'POST', body: fd, headers:{ 'Accept':'application/json' } });
      if(res.ok){ await refreshCart(); openDrawer('CartDrawer'); }
      else{ const j = await res.json().catch(()=>({})); alert(j.description || 'Could not add to cart'); }
    }catch(err){ console.error(err); }
    finally{ if(btn){ btn.disabled = false; btn.innerHTML = orig; } }
  });

  /* Cart quantity change & remove */
  document.addEventListener('change', async e => {
    const qty = e.target.closest('[data-cart-line-qty]');
    if(!qty) return;
    const key = qty.dataset.lineKey;
    const v = parseInt(qty.value, 10);
    await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id:key, quantity:v }) });
    refreshCart();
  });
  document.addEventListener('click', async e => {
    const rm = e.target.closest('[data-cart-remove]');
    if(!rm) return;
    e.preventDefault();
    const key = rm.dataset.lineKey;
    await fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({ id:key, quantity:0 }) });
    refreshCart();
  });

  /* ---------- Sofa cover try-on ---------- */
  $$('[data-sofa-tryon]').forEach(scope => {
    const swatches = $$('.sofa-tryon__swatch', scope);
    const previews = $$('.sofa-tryon__preview-img', scope);
    const nameOut = $('[data-product-name-out]', scope);
    const priceOut = $('[data-product-price-out]', scope);
    const compareOut = $('[data-product-compare-out]', scope);
    const ctaSlot = $('[data-product-cta-out]', scope);
    if(!swatches.length) return;

    // Preload preview images (J upgrade)
    swatches.forEach(s => {
      if(s.dataset.previewSrc){ const img = new Image(); img.src = s.dataset.previewSrc; }
    });

    function selectCover(idx){
      swatches.forEach((s,i) => {
        s.classList.toggle('is-active', i===idx);
        s.setAttribute('aria-checked', i===idx ? 'true' : 'false');
      });
      previews.forEach((p,i) => p.classList.toggle('is-active', i===idx));

      const s = swatches[idx];
      if(!s) return;
      if(nameOut){
        nameOut.textContent = s.dataset.productTitle || '';
        nameOut.href = s.dataset.productUrl || '#';
      }
      if(priceOut) priceOut.textContent = s.dataset.productPrice || '';
      if(compareOut){
        const c = s.dataset.productCompare;
        if(c){ compareOut.textContent = c; compareOut.removeAttribute('hidden'); }
        else { compareOut.textContent = ''; compareOut.setAttribute('hidden',''); }
      }
      if(ctaSlot){
        const isDefault = s.dataset.productDefaultVariant === 'true';
        const isAvail = s.dataset.productAvailable === 'true';
        if(isDefault && isAvail){
          ctaSlot.innerHTML = `<form action="/cart/add" method="post" data-tryon-form>
            <input type="hidden" name="id" value="${s.dataset.variantId}">
            <button type="submit" class="btn btn--primary">Add to cart</button>
          </form>`;
        } else if(isAvail){
          ctaSlot.innerHTML = `<a href="${s.dataset.productUrl}" class="btn btn--primary">Select options →</a>`;
        } else {
          ctaSlot.innerHTML = `<button type="button" class="btn btn--primary" disabled style="opacity:.6">Sold out</button>`;
        }
      }
    }

    swatches.forEach((sw, idx) => {
      sw.addEventListener('click', () => selectCover(idx));
      sw.addEventListener('keydown', e => {
        if(e.key === 'ArrowRight' || e.key === 'ArrowDown'){
          e.preventDefault();
          const n = (idx + 1) % swatches.length;
          selectCover(n); swatches[n].focus();
        } else if(e.key === 'ArrowLeft' || e.key === 'ArrowUp'){
          e.preventDefault();
          const n = (idx - 1 + swatches.length) % swatches.length;
          selectCover(n); swatches[n].focus();
        }
      });
    });

    // Compare mode toggle
    const toggle = $('[data-compare-toggle]', scope);
    const singleStage = $('[data-stage-single]', scope);
    const compareStage = $('[data-stage-compare]', scope);
    const exitBtn = $('[data-compare-exit]', scope);
    const overlayImg = $('[data-compare-overlay]', scope);
    const baseImg = $('[data-compare-base]', scope);
    const overlayPick = $('[data-compare-pick="overlay"]', scope);
    const basePick = $('[data-compare-pick="base"]', scope);
    const handle = $('[data-compare-handle]', scope);
    const frame = $('[data-compare-frame]', scope);

    function enterCompare(){
      if(!compareStage) return;
      singleStage.hidden = true;
      compareStage.hidden = false;
      if(toggle) toggle.setAttribute('aria-pressed', 'true');
    }
    function exitCompare(){
      if(!compareStage) return;
      singleStage.hidden = false;
      compareStage.hidden = true;
      if(toggle) toggle.setAttribute('aria-pressed', 'false');
    }
    toggle && toggle.addEventListener('click', enterCompare);
    exitBtn && exitBtn.addEventListener('click', exitCompare);

    function getCoverSrc(idx){
      const sw = swatches[idx];
      return sw && sw.dataset.previewSrc;
    }
    overlayPick && overlayPick.addEventListener('change', () => {
      const src = getCoverSrc(parseInt(overlayPick.value,10));
      if(src && overlayImg) overlayImg.src = src;
    });
    basePick && basePick.addEventListener('change', () => {
      const src = getCoverSrc(parseInt(basePick.value,10));
      if(src && baseImg) baseImg.src = src;
    });

    // Drag handle (pointer events — works for mouse, pen, touch)
    if(handle && frame && overlayImg){
      let dragging = false;
      function setSplit(percent){
        percent = Math.max(0, Math.min(100, percent));
        overlayImg.style.clipPath = `inset(0 ${100-percent}% 0 0)`;
        handle.style.left = `${percent}%`;
      }
      function pointerMove(e){
        if(!dragging) return;
        const rect = frame.getBoundingClientRect();
        const x = e.clientX !== undefined ? e.clientX : (e.touches && e.touches[0].clientX);
        if(x === undefined) return;
        setSplit(((x - rect.left) / rect.width) * 100);
      }
      function start(e){ dragging = true; frame.setPointerCapture && e.pointerId !== undefined && frame.setPointerCapture(e.pointerId); pointerMove(e); }
      function end(){ dragging = false; }
      frame.addEventListener('pointerdown', start);
      window.addEventListener('pointermove', pointerMove);
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      // Keyboard on handle
      handle.addEventListener('keydown', e => {
        const cur = parseFloat(handle.style.left) || 50;
        if(e.key === 'ArrowRight'){ e.preventDefault(); setSplit(cur + 5); }
        else if(e.key === 'ArrowLeft'){ e.preventDefault(); setSplit(cur - 5); }
      });
      setSplit(50);
    }
  });

  /* ---------- Featured videos: lazy autoplay + per-card mute ---------- */
  const fvVideos = $$('[data-fv-video]');
  if(fvVideos.length && 'IntersectionObserver' in window){
    const loadSources = v => {
      v.querySelectorAll('source[data-src]').forEach(s => {
        if(!s.src){ s.src = s.dataset.src; s.removeAttribute('data-src'); }
      });
      if(v._loaded !== true){ try{ v.load(); v._loaded = true; }catch(e){} }
    };
    const io = new IntersectionObserver(entries => {
      // Modal-aware: if story modal is open, never play inline cards
      const modalOpen = storyModal && storyModal.classList.contains('is-open');
      entries.forEach(entry => {
        const v = entry.target;
        const media = v.closest('.featured-videos__media');
        if(!modalOpen && entry.isIntersecting && entry.intersectionRatio >= 0.5){
          loadSources(v);
          const p = v.play();
          if(p && p.catch) p.catch(() => {});
          if(media) media.classList.add('is-playing');
        } else {
          try{ v.pause(); }catch(e){}
          if(media) media.classList.remove('is-playing');
        }
      });
    }, { threshold: [0, 0.5, 0.75, 1] });
    fvVideos.forEach(v => io.observe(v));

    // Per-card mute toggle
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-fv-mute]');
      if(!btn) return;
      e.preventDefault();
      e.stopPropagation();
      const card = btn.closest('.featured-videos__card');
      const v = card && card.querySelector('[data-fv-video]');
      if(!v) return;
      v.muted = !v.muted;
      card.classList.toggle('is-unmuted', !v.muted);
      // Mute all other cards when unmuting this one (only one audible at a time)
      if(!v.muted){
        fvVideos.forEach(other => {
          if(other !== v){ other.muted = true; const oc = other.closest('.featured-videos__card'); if(oc) oc.classList.remove('is-unmuted'); }
        });
      }
    });
  }

  /* ---------- Variant picker basic ---------- */
  document.addEventListener('change', e => {
    const wrap = e.target.closest('[data-product-form]');
    if(!wrap || !e.target.matches('input[name^="options"]')) return;
    const product = JSON.parse(wrap.dataset.product || 'null');
    if(!product) return;
    const selected = $$('input[name^="options"]:checked', wrap).map(i => i.value);
    const variant = product.variants.find(v => v.options.every((o,i) => o === selected[i]));
    const idInput = $('input[name="id"]', wrap);
    const priceEl = $('[data-price]', wrap.closest('.product') || document);
    const btn = $('[type=submit]', wrap);
    if(variant){
      if(idInput) idInput.value = variant.id;
      if(priceEl) priceEl.textContent = variant.price_formatted || variant.price;
      if(btn){
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? (btn.dataset.addText || 'Add to cart') : (btn.dataset.soldText || 'Sold out');
      }
    }
  });

  /* ---------- Tabbed collections ---------- */
  $$('[data-tabs]').forEach(scope => {
    const tabs = $$('.tab-btn', scope);
    const panels = $$('.tab-panel', scope);
    const indicator = $('[data-tab-indicator]', scope);
    if(!tabs.length) return;

    function moveIndicator(idx){
      if(!indicator || !tabs[idx]) return;
      const t = tabs[idx];
      indicator.style.left = t.offsetLeft + 'px';
      indicator.style.width = t.offsetWidth + 'px';
    }

    function setupDots(panel){
      const grid = $('[data-products-grid]', panel);
      const dotsBox = $('[data-dots]', panel);
      if(!grid || !dotsBox) return;
      const cards = $$('.product-card', grid);
      if(window.innerWidth >= 990 || cards.length < 2){ dotsBox.innerHTML = ''; return; }
      dotsBox.innerHTML = '';
      cards.forEach(() => dotsBox.appendChild(document.createElement('span')));
      const update = () => {
        const sl = grid.scrollLeft;
        const cw = cards[0].offsetWidth + (parseInt(getComputedStyle(grid).columnGap) || 0);
        if(!cw) return;
        const idx = Math.min(cards.length - 1, Math.round(sl / cw));
        $$('span', dotsBox).forEach((d,i) => d.classList.toggle('is-active', i === idx));
      };
      grid.addEventListener('scroll', update, {passive:true});
      update();
    }

    function activateTab(idx){
      tabs.forEach((t,i) => {
        const active = i === idx;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
        t.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach((p,i) => {
        if(i === idx){
          p.classList.add('is-fading');
          p.removeAttribute('hidden');
          p.classList.add('is-active');
          requestAnimationFrame(() => requestAnimationFrame(() => p.classList.remove('is-fading')));
          setTimeout(() => setupDots(p), 50);
        } else {
          p.classList.remove('is-active');
          p.setAttribute('hidden', '');
        }
      });
      moveIndicator(idx);
      // Scroll active tab into view on mobile
      const strip = tabs[idx].parentElement;
      if(strip && strip.scrollWidth > strip.clientWidth){
        const t = tabs[idx];
        const center = t.offsetLeft - (strip.clientWidth/2) + (t.offsetWidth/2);
        strip.scrollTo({ left: Math.max(0, center), behavior: 'smooth' });
      }
    }

    tabs.forEach((tab, idx) => {
      tab.addEventListener('click', () => activateTab(idx));
      tab.addEventListener('keydown', e => {
        if(e.key === 'ArrowRight'){
          e.preventDefault();
          const n = (idx + 1) % tabs.length;
          activateTab(n); tabs[n].focus();
        } else if(e.key === 'ArrowLeft'){
          e.preventDefault();
          const n = (idx - 1 + tabs.length) % tabs.length;
          activateTab(n); tabs[n].focus();
        } else if(e.key === 'Home'){
          e.preventDefault(); activateTab(0); tabs[0].focus();
        } else if(e.key === 'End'){
          e.preventDefault(); activateTab(tabs.length-1); tabs[tabs.length-1].focus();
        }
      });
    });

    // Initial setup
    requestAnimationFrame(() => {
      const startIdx = tabs.findIndex(t => t.classList.contains('is-active'));
      moveIndicator(startIdx >= 0 ? startIdx : 0);
      const activePanel = panels.find(p => p.classList.contains('is-active'));
      if(activePanel) setupDots(activePanel);
    });

    window.addEventListener('resize', () => {
      const cur = tabs.findIndex(t => t.classList.contains('is-active'));
      moveIndicator(cur >= 0 ? cur : 0);
      const activePanel = panels.find(p => p.classList.contains('is-active'));
      if(activePanel) setupDots(activePanel);
    });
  });

  /* ---------- Story modal (shared by Story Circles + Featured Videos) ---------- */
  const storyModal = $('[data-story-modal]');
  if(storyModal){
    const progressBox = $('[data-progress]', storyModal);
    const mediaSlot = $('[data-story-media]', storyModal);
    let activeGroup = null;
    let activeSlideIdx = 0;
    let activeVideo = null;
    let muted = true;

    function openStory(cat){
      // Search globally — groups live in any .story-pool across the page
      const safe = cat.replace(/"/g,'\\"');
      const group = document.querySelector(`.story-group[data-category="${safe}"]`);
      if(!group) return;
      // Remember origin for restore
      group._originalParent = group.parentNode;
      group._originalNextSibling = group.nextSibling;
      // Move into modal
      if(mediaSlot){ mediaSlot.innerHTML = ''; mediaSlot.appendChild(group); }
      group.classList.add('is-active');
      activeGroup = group;
      const slides = $$('.story-slide', group);
      progressBox.innerHTML = '';
      slides.forEach(() => progressBox.appendChild(document.createElement('span')));
      // Pause all inline videos (e.g. featured-videos cards behind the modal)
      $$('[data-fv-video]').forEach(v => { try{ v.pause(); }catch(e){} });
      storyModal.classList.add('is-open');
      storyModal.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';
      showSlide(0);
    }

    function showSlide(i){
      if(!activeGroup) return;
      const slides = $$('.story-slide', activeGroup);
      if(i < 0) i = 0;
      if(i >= slides.length){ closeStory(); return; }
      if(activeVideo){ try{ activeVideo.pause(); activeVideo.currentTime = 0; }catch(e){} }
      slides.forEach((s, idx) => s.classList.toggle('is-active', idx === i));
      const bars = $$('span', progressBox);
      bars.forEach((b, idx) => {
        b.classList.toggle('is-seen', idx < i);
        b.classList.toggle('is-active', idx === i);
      });
      const v = slides[i].querySelector('video');
      if(v){
        v.muted = muted;
        const p = v.play();
        if(p && p.catch) p.catch(() => {});
        activeVideo = v;
      } else {
        activeVideo = null;
      }
      activeSlideIdx = i;
    }

    function closeStory(){
      storyModal.classList.remove('is-open');
      storyModal.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';
      if(activeVideo){ try{ activeVideo.pause(); }catch(e){} activeVideo = null; }
      // Restore group to its original location in the page
      if(activeGroup && activeGroup._originalParent){
        activeGroup.classList.remove('is-active');
        activeGroup._originalParent.insertBefore(activeGroup, activeGroup._originalNextSibling || null);
        activeGroup._originalParent = null;
        activeGroup._originalNextSibling = null;
      }
      activeGroup = null;
    }

    // Any trigger anywhere on the page
    document.addEventListener('click', e => {
      const c = e.target.closest('[data-story-open]');
      if(!c) return;
      e.preventDefault();
      openStory(c.dataset.storyOpen);
    });

    function showToast(msg){
      let t = document.querySelector('.story-share-toast');
      if(!t){ t = document.createElement('div'); t.className = 'story-share-toast'; document.body.appendChild(t); }
      t.textContent = msg;
      requestAnimationFrame(() => t.classList.add('is-visible'));
      clearTimeout(t._h);
      t._h = setTimeout(() => t.classList.remove('is-visible'), 1800);
    }

    async function shareActiveSlide(){
      if(!activeGroup) return;
      const slide = $('.story-slide.is-active', activeGroup);
      if(!slide) return;
      const url = slide.dataset.shareUrl || window.location.href;
      const title = slide.dataset.shareTitle || document.title;
      if(navigator.share){
        try{ await navigator.share({ title, url }); }catch(e){ /* user cancelled */ }
      } else if(navigator.clipboard){
        try{ await navigator.clipboard.writeText(url); showToast('Link copied'); }
        catch(e){ window.prompt('Copy link:', url); }
      } else {
        window.prompt('Copy link:', url);
      }
    }

    storyModal.addEventListener('click', e => {
      if(e.target.closest('[data-story-close]')){ e.preventDefault(); closeStory(); return; }
      if(e.target.closest('[data-story-prev]')){ e.preventDefault(); showSlide(activeSlideIdx - 1); return; }
      if(e.target.closest('[data-story-next]')){ e.preventDefault(); showSlide(activeSlideIdx + 1); return; }
      if(e.target.closest('[data-story-mute]')){
        e.preventDefault();
        muted = !muted;
        storyModal.classList.toggle('is-unmuted', !muted);
        if(activeVideo) activeVideo.muted = muted;
        return;
      }
      if(e.target.closest('[data-story-share]')){ e.preventDefault(); shareActiveSlide(); return; }
      if(e.target.closest('[data-story-cart]')){
        e.preventDefault();
        closeStory();
        setTimeout(() => openDrawer('CartDrawer'), 250);
        return;
      }
    });

    document.addEventListener('keydown', e => {
      if(!storyModal.classList.contains('is-open')) return;
      if(e.key === 'Escape'){ closeStory(); }
      else if(e.key === 'ArrowLeft'){ showSlide(activeSlideIdx - 1); }
      else if(e.key === 'ArrowRight'){ showSlide(activeSlideIdx + 1); }
    });
  }

})();
